export function gridFields() {
    return Object.freeze([{
      key: 'id',
      label: 'lbl.basic.id',
      uneditable: true,
      notInTable: true,
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'date',
      label: 'lbl.basic.date',
      sortable: true,
      form: {
        type: 'datepicker'
      }
    },
    {
        key: 'time',
        label: 'lbl.basic.datetime',
        sortable: true,
        form: {
          type: 'timepicker'
        }
    },
    {
        key: 'shiftName',
        label: 'lbl.shiftPlan.shiftName',
        sortable: true,
        default: 'default',
        form: {
            type: 'input',
            options: [
                {value:"default", text:"lbl.basic.select.one"},
                {value:'甲', text:"lbl.shift.A"},
                {value:'乙', text:"lbl.shift.B"},
                {value:'丙', text:"lbl.shift.C"},
            ]
        }
    },
    {
      key: 'startDate',
      label: 'lbl.basic.startTime',
      uneditable: true,
      notInTable: true,
      // default: new Date,
      filterable: true,
      form: {
        type: 'datepicker',
      }
    },
    {
      key: 'endDate',
      label: 'lbl.basic.endTime',
      notInTable: true,
      uneditable: true,
      // default: nextYear,
      filterable: true,
      form: {
        type: 'datepicker',
      }
    },
    {
      key: 'locName',
      label: 'lbl.fm.locationName',
      filterable: true,
      default: 'default',
      form: {
        type: 'dimSearch',
        url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/location/findAll',
        config: {
          validate: "", // 参数检查，可以是正则表达式等
          bindId: 'smeltingLocation', // 绑定的 id, (id 相同的对象会被绑定)
          bindProp: "locName", // 显示的属性的名称
          submitProp: "locName" // 提交的属性
        }
      }
    },
    {
      key: 'locId',
      label: 'lbl.formulaPlan.locationCode',
      notInTable: true,
      form: {
        type: 'dimSearch',
        url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/location/findAll',
        config: {
          validate: "", // 参数检查，可以是正则表达式等
          bindId: 'smeltingLocation', // 绑定的 id, (id 相同的对象会被绑定)
          bindProp: "id", // 显示的属性的名称
          submitProp: "id" // 提交的属性
        }
      }
    },
    {
        key: 'furnaceNumber',
        label: 'lbl.basic.furnaceName',
        filterable: true,
        sortable: true,
        default: 'default',
        form: {
          type: 'select',
          options: [
            {value:"default", text:"lbl.basic.select.one"},
            {value:"1", text:"opt.furnaceNumber1"},
            {value:"2", text:"opt.furnaceNumber2"},
            {value:"3", text:"opt.furnaceNumber3"},
            {value:"4", text:"opt.furnaceNumber4"},
            {value:"5", text:"opt.furnaceNumber5"},
            {value:"6", text:"opt.furnaceNumber6"}
          ]
        }
    },
    {
        key: 'feed1',
        label: 'lbl.sip.feed1',
        sortable: true,
        form: {
          type: 'input'
        }
    },
    {
        key: 'feed2',
        label: 'lbl.sip.feed2',
        sortable: true,
        form: {
          type: 'input'
        }
    },
    {
        key: 'feed3',
        label: 'lbl.sip.feed3',
        sortable: true,
        form: {
          type: 'input'
        }
    },
    {
        key: 'feed4',
        label: 'lbl.sip.feed4',
        sortable: true,
        form: {
          type: 'input'
        }
    },
    {
        key: 'feed5',
        label: 'lbl.sip.feed5',
        sortable: true,
        form: {
          type: 'input'
        }
    },
    {
        key: 'feed6',
        label: 'lbl.sip.feed6',
        sortable: true,
        form: {
          type: 'input'
        }
    },
    {
        key: 'feed7',
        label: 'lbl.sip.feed7',
        sortable: true,
        form: {
          type: 'input'
        }
    },
    {
        key: 'feed8',
        label: 'lbl.sip.feed8',
        sortable: true,
        form: {
          type: 'input'
        }
    },
    {
        key: 'feed9',
        label: 'lbl.sip.feed9',
        sortable: true,
        form: {
          type: 'input'
        }
    },
    {
        key: 'shiftTotal',
        label: 'lbl.sip.shiftTotal',
        sortable: true,
        form: {
          type: 'input'
        }
    },
    {
        key: 'dailyTotal',
        label: 'lbl.sip.dailyTotal',
        sortable: true,
        form: {
          type: 'input'
        }
    },
    {
        key: 'tubeTotal',
        label: 'lbl.sip.tubeTotal',
        sortable: true,
        form: {
          type: 'input'
        }
    },
    {
        key: 'pelletFeedBelt',
        label: 'lbl.sip.pelletFeedBelt',
        sortable: true,
        form: {
          type: 'input'
        }
    }
    ]);
  }
  
  // class
  export const PelletFeeding = function () {
    gridFields().forEach(item => {
      this[item.key] = item.default || '';
    })
  }
  
  
  export const filter = gridFields()
    .filter(v => v.filterable)
    .reduce((tar, v) => {
      tar[`${v.key}Filter`] = v.default || '';
      return tar
    }, {})
  export const filterFields = gridFields().filter(v => v.filterable).map(v => `filter.${v.key}`)